import { css } from '@emotion/css';

export const tableStyles = css`
  .BaseTable__header-cell,
  .BaseTable__row-cell {
    padding: 0 !important;
  }

  .BaseTable__row {
    border-bottom: none !important;
  }

  .BaseTable__row {
    .BaseTable__row-cell {
      overflow: visible !important;
    }

    .BaseTable__row-cell .content,
    .BaseTable__row-cell .group-list-item {
      border-bottom: 1px solid var(--interactive-border) !important;
    }

    :hover .BaseTable__row-cell :not(.disabled).content,
    :hover .BaseTable__row-cell :not(.disabled).group-list-item {
      box-shadow: 0px -1px 0px 0px var(--bg-primary);
      border-color: transparent !important;
    }

    :last-of-type {
      .BaseTable__row-cell .content,
      .BaseTable__row-cell .group-list-item {
        border: none !important;
      }
    }
  }

  .BaseTable__body {
    padding-bottom: 2.4rem !important;
  }
`;
